import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_FALLBACK_LANGUAGE } from 'Constants/App';
import FormattedNumber from 'Components/FormattedNumber';
import { getLocale } from 'Shared/utils/UtilsHelper';

function FormattedPrice(props) {
    const {
        price, currency, currencyDisplay, fractionDigits,
        language, country,
    } = props;

    return (
        <FormattedNumber
            value={price}
            currencyDisplay={currencyDisplay}
            currency={currency}
            styled
            isPlainNumber
            fractionDigits={fractionDigits}
            language={getLocale(language, country)}
        />
    );
}

FormattedPrice.defaultProps = {
    currency        : null,
    currencyDisplay : 'code',
    fractionDigits  : 2,
    price           : 0.00,
    language        : DEFAULT_FALLBACK_LANGUAGE,
};

FormattedPrice.propTypes = {
    price           : PropTypes.number,
    currency        : PropTypes.object,
    currencyDisplay : PropTypes.string,
    fractionDigits  : PropTypes.number,
    language        : PropTypes.string,
    country         : PropTypes.string.isRequired,
};

export default FormattedPrice;
